import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'app-alertInsufficientPopup',
    templateUrl: './alertInsufficientPopup.layout.mobile.component.html',
    styleUrls: ['../css/alertInsufficientPopup.layout.mobile.component.scss'],
    standalone: false
})
export class alertInsufficientPopupMobileComponent {
  @Input() alertData: any;
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();
  menu_icons: any;
  currentLanguage: any;
  errorStatusString = 'LANG00029';
  errorStatusOnlyText: boolean;
  version = '';
  constructor() {}

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }

  onCloseClick = (event = null) => {
    this.eventEmit.emit('close');
  };

  onAlertImageClick = (event = null) => {
    //console.log('onAlertImageClick');
    /* this.eventEmit.emit(this.data.iconStr); */
  };

  ngOnInit() {
    //console.log("alertInsufficientPopupMobileComponent..",this.alertData)
    if (this.alertData) {
      if (this.alertData.currentLanguage) {
        this.currentLanguage = this.alertData.currentLanguage;
      }
      if (this.alertData.errorStatusString != undefined) {
        this.errorStatusString = this.alertData.errorStatusString;
      }
      if (this.alertData.errorStatusOnlyText) {
        this.errorStatusOnlyText = this.alertData.errorStatusOnlyText;
      }
    }
  }
  ngOnDestroy() {
    delete this.alertData;
    delete this.menu_icons;
    delete this.currentLanguage;
    delete this.errorStatusString;
    delete this.errorStatusOnlyText;
    delete this.version;
  }
}
